import React from "react";
import PropTypes from "prop-types";

export default (WrappedComponent) => {
  const hocComponent = ({ ...props }) => (
    <div
      className="h-screen w-screen flex justify-center items-center background-4 bg-blue-400"
      style={{ backgroundColor: "#63b3ed" }}
    >
      <div
        className="w-7/12 h-56 rounded shadow-2xl flex items-center flex-col py-4"
        style={{ backgroundColor: "rgba(255,255,255,0.9)", height: "60vh" }}
      >
        <WrappedComponent {...props} />
      </div>
    </div>
  );

  hocComponent.propTypes = {};

  return hocComponent;
};
